import { StandaloneStudiesMap } from './derive-chat-flags';

export const CALL_PHASES = {
    ACTIVE: 'active',
    ENDED: 'ended',
} as const;

export const CALL_VIEW_MODES = {
    FULLSCREEN: 'fullscreen',
    MINIMIZED: 'minimized',
} as const;

export const CALL_TYPES = {
    VOICE: 'voice',
    VIDEO: 'video',
} as const;

export type CallPhase = (typeof CALL_PHASES)[keyof typeof CALL_PHASES];
export type CallType = (typeof CALL_TYPES)[keyof typeof CALL_TYPES];

export interface ChatAuthTokenPayload {
    accessToken: string;
    refreshToken: string;
    expiresIn?: number;
}

export interface ChatInitPayload {
    studyId: number;
    studies: StandaloneStudiesMap;
    locale?: string;
}

export interface ChatStudyChangedPayload {
    studyId: number;
    studies: StandaloneStudiesMap;
}

export interface AnswerCallPayload {
    callId: string;
    withVideo: boolean;
}

export interface RejectCallPayload {
    callId: string;
}

export interface HangupCallPayload {
    callId: string;
}

export type CallViewMode = (typeof CALL_VIEW_MODES)[keyof typeof CALL_VIEW_MODES];

export interface SetCallViewPayload {
    mode: CallViewMode;
}

export type CallStateChangedPayload =
    | {
          state: typeof CALL_PHASES.ACTIVE;
          callId: string;
          callerName: string | null;
          callType: CallType;
      }
    | {
          state: typeof CALL_PHASES.ENDED;
          callId: string;
          callerName: null;
          callType: null;
      };

export interface CallViewChangedPayload {
    mode: CallViewMode;
}
